import { DATE_TIME_FORMAT_NAME_MODEL, errorMsg, getDateWithFormat } from "../../../../../Apis/functions";
import { ConnectWithHid, ResetHid, SendInformationSetting } from "../../../../../reduxToolkit/HID/HidApi";
import {toast} from "react-toastify";
import {t} from "i18next";
import moment from "moment";
import {timeZone} from "../../../../../enums/timeZoneEnum";

export const MIN_MAX_CONTROLLER = {
    OFFSET: { start: 100 }
}

// Time zones of the controller, from UTC-12 to UTC+12, sent as their offset in minutes (utcOffsetMinutes)
export const CONTROLLER_TIME_ZONES = Object.entries(timeZone).map(([key, name]) => ({
    utcOffsetMinutes: (parseInt(key) - 13) * 60,
    name
}));

// While daylight saving is on, the clock moves one hour ahead of the standard time
export const DAYLIGHT_SAVING_SHIFT_MINUTES = 60;

/**
 * Writes the date and time picked, as the controller wall clock, with the given offset (2026-03-08T02:00:00-05:00).
 */
const toOffsetDateTime = (date, offsetMinutes) =>
    `${getDateWithFormat(date, DATE_TIME_FORMAT_NAME_MODEL.isoDateTime)}${moment().utcOffset(offsetMinutes).format('Z')}`;

/**
 * Reads a date with offset back as the controller wall clock, so the picker shows the same date and time it was saved with.
 */
const fromOffsetDateTime = (value) =>
    value ? moment(getDateWithFormat(moment.parseZone(value), DATE_TIME_FORMAT_NAME_MODEL.isoDateTime)).toDate() : null;

export const STATUS_CONTROLLER = {
    ACTIVE: {
        id: 1,
        name: 'active'
    },
    VACATIONS: {
        id: 2,
        name: 'vacations'
    },
    LOCKED: {
        id: 3,
        name: 'locked'
    },
    INACTIVE: {
        id: 4,
        name: 'inactive'
    }
}


export const CONTROLLER_DATA = {
    id: null,
    channelId: null,
    ipAddress: null,
    statusId: null,
    scpId: null,
    name: "",
    description: "",
    formats: [],
    sios: [],
    offset: null,
    utcOffsetMinutes: null,
    daylightSavingEnabled: false,
    daylightSavingStart: null,
    daylightSavingEnd: null,
    toAddEdit: function () {
        return {
            id: this.id,
            channelId: parseInt(this.channelId),
            hidName: this.name,
            ipAddress: this.ipAddress,
            statusId: parseInt(this.statusId),
            scpId: parseInt(this.scpId),
            name: this.name,
            description: this.description || null,
            offset:  parseInt(this.offset),
            utcOffsetMinutes: parseInt(this.utcOffsetMinutes),
            daylightSavingEnabled: this.daylightSavingEnabled,
            // The start is still in standard time, while the end is already in daylight saving time
            daylightSavingStart: this.daylightSavingEnabled
                ? toOffsetDateTime(this.daylightSavingStart, parseInt(this.utcOffsetMinutes))
                : null,
            daylightSavingEnd: this.daylightSavingEnabled
                ? toOffsetDateTime(this.daylightSavingEnd, parseInt(this.utcOffsetMinutes) + DAYLIGHT_SAVING_SHIFT_MINUTES)
                : null,
        }
    },
    isValid: function () {
        return this.channelId != null && this.name != null && this.name !== '' && this.ipAddress != null && this.statusId != null
            && this.scpId != null &&  this.offset !== null && this.utcOffsetMinutes !== null && this.utcOffsetMinutes !== ''
            && (!this.daylightSavingEnabled || (this.daylightSavingStart != null && this.daylightSavingEnd != null))
            && this.isValidDaylightSavingRange();
    },
    // The daylight saving must end after it starts
    isValidDaylightSavingRange: function () {
        return !this.daylightSavingEnabled || !this.daylightSavingStart || !this.daylightSavingEnd
            || moment(this.daylightSavingStart).isBefore(this.daylightSavingEnd);
    },
    set: function (data) {
       return {
           ...this,
           id: data.id,
           channelId: data?.channelId,
           ipAddress: data?.ipAddress,
           statusId: data?.statusId,
           scpId: data?.scpId,
           name: data?.name,
           description: data?.description || null,
           offset: data?.offset,
           utcOffsetMinutes: data?.utcOffsetMinutes ?? null,
           daylightSavingEnabled: data?.daylightSavingEnabled === true,
           daylightSavingStart: fromOffsetDateTime(data?.daylightSavingStart),
           daylightSavingEnd: fromOffsetDateTime(data?.daylightSavingEnd),
       }
    }
}

    /**
     * Connect controller to HID
     * Shows success or error toast based on API response
     */
   export  const handleConnect = (dispatch, id) => {
       
        dispatch(ConnectWithHid({ id })).then(
            ({ payload: { data: { data, code, success } } }) => {
                if (success) {
                    toast.success(t('has_been_connected_successfully'));
                } else {
                    errorMsg(code);
                }
            },
        );
    };

    /**
     * Send configuration to controller
     */
   export const handleSetConfig = (dispatch, id) => {
        dispatch(SendInformationSetting({ id })).then(
            ({ payload: { data: { data, code, success } } }) => {
               if (success) {
                toast.success(t('has_been_configured_successfully'));
            } else {
                errorMsg(code);
            }
            }
        );
    };

    /**
     * Reset the controller
     */
    export const handleReset = (dispatch, id) => {
        dispatch(ResetHid({ id })).then(
            ({ payload: { data: { data, code, success } } }) => {
                if (success) {
                toast.success(t('has_been_reset_successfully'));
            } else {
                errorMsg(code);
            }
            }
        );
    };
